import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 


const LabelChangeList = lazy(() => import("../pages/labelchange/LabelChangeList"));
const LabelChangeEdit = lazy(() => import("../pages/labelchange/LabelChangeEdit"));
const LabelChangeAdd = lazy(() => import("../pages/labelchange/LabelChangeAdd"));



const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="/labelchange" />
    ),
  },
  {
    path: "/labelchange",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <LabelChangeList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/labelchange/edit-label",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
           <LabelChangeEdit /> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/labelchange/add-label",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <LabelChangeAdd/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
];

const Router = createBrowserRouter(routesForm);

export { Router };